import { render, staticRenderFns } from "./EmailShare.vue?vue&type=template&id=0bab3e11&scoped=true"
import script from "./EmailShare.vue?vue&type=script&lang=js"
export * from "./EmailShare.vue?vue&type=script&lang=js"
import style0 from "./EmailShare.vue?vue&type=style&index=0&id=0bab3e11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab3e11",
  null
  
)

export default component.exports